import { render, staticRenderFns } from "./StatsBox.vue?vue&type=template&id=f967272a&scoped=true&"
import script from "./StatsBox.vue?vue&type=script&lang=js&"
export * from "./StatsBox.vue?vue&type=script&lang=js&"
import style0 from "./StatsBox.vue?vue&type=style&index=0&id=f967272a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f967272a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/StatsBox.vue
// module id = null
// module chunks = 